import { theme } from '@zappyrent/hundop';
import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import Media from 'react-media';
import { useNavigate } from 'react-router-dom';

import { StyledStickyBox } from '../../../pages/UploadDocuments/UploadDocuments.styles';
import {
  StyledArrowLeft,
  StyledBackButton,
  StyledButtonsContainer,
  StyledContinueButton,
  StyledSpinner,
} from './ActionBar.styles';
import { IActionBarProps } from './ActionBar.types';

const ActionBar = ({
  isInHeader,
  isLoading,
  isContinueButtonDisabled,
  onContinue,
}: IActionBarProps): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const continueButton = (
    <StyledContinueButton
      onClick={onContinue}
      title="continua"
      variant="primary"
      disabled={isContinueButtonDisabled}
    >
      <span>
        {isLoading && (
          <StyledSpinner
            backgroundColor={rgba(theme.colors.main, 0.2)}
            foregroundColor={theme.colors.main}
          />
        )}
        {t('continue')}
      </span>
    </StyledContinueButton>
  );

  const backButton = (
    <StyledBackButton
      onClick={() => {
        navigate(-1);
      }}
      title="indietro"
    >
      <StyledArrowLeft />
      {t('back')}
    </StyledBackButton>
  );

  return (
    <Media
      queries={{
        mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
        desktop: `(min-width: ${theme.breakpoints.l})`,
      }}
      defaultMatches={{ desktop: true }}
    >
      {matches => (
        <>
          {matches.desktop && (
            <StyledButtonsContainer>
              {backButton}
              {continueButton}
            </StyledButtonsContainer>
          )}
          {matches.mobile && (
            <>
              {isInHeader ? (
                backButton
              ) : (
                <StyledStickyBox>{continueButton}</StyledStickyBox>
              )}
            </>
          )}
        </>
      )}
    </Media>
  );
};

export default ActionBar;
